<template>
  <header class="px-3 sm:px-6 py-3 sm:py-4 border-b border-b-gray-200 relative">
    <h3 class="font-serif text-2xl text-gray-600 leading-none mr-5 break-long-string">
      <slot />
    </h3>
  </header>
</template>
